import { ApolloClient } from '@apollo/client'
import gql from 'graphql-tag'
import { MutateSigningCertificateFingerprintStatus } from '../../../api'

export const MUTATION = gql`
  mutation DeleteSigningCertificateFingerprint(
    $input: DeleteSigningCertificateFingerprintInput!
  ) {
    deleteSigningCertificateFingerprint(input: $input) {
      id
    }
  }
`

export const deleteSigningCertificateFingerprint = async (
  client: ApolloClient<unknown>,
  fingerprint: string,
): Promise<MutateSigningCertificateFingerprintStatus | undefined> => {
  const mutationResult = await client.mutate<{
    deleteSigningCertificateFingerprint: MutateSigningCertificateFingerprintStatus
  }>({
    mutation: MUTATION,
    variables: {
      input: { fingerprint },
    },
  })

  return mutationResult.data?.deleteSigningCertificateFingerprint
}
